import React from 'react';
import { Dialog } from 'primereact/dialog';
import { ModalHeader } from 'shared/ModalHeader';
import { Button } from 'primereact/button';

export const UpdateContactDialog = ({ visible, onHide, onRetain, onReset, isDefendant }) => {
  return (
    <Dialog visible={visible} onHide={onHide} header={ModalHeader} modal closable={false}>
      <div className="modal-heading F-size16 text-bold mb-3">
        Would you like to retain or reset the {isDefendant ? 'defendant' : 'client'} claim information?
      </div>
      <div className="d-flex justify-content-end gap-2 mt-4">
        <Button label="Retain" className="p-button-secondary" onClick={onRetain} />
        <Button label="Reset" className="p-button-secondary" onClick={onReset} />
      </div>
    </Dialog>
  );
};
